export default{
    totalAccount:'totalAccount',
    totalAccountTitle: 'Title',
    unitStatus: 'Status',
    totalAccounts:'total Account',
    accountGroupTitle:'account Group',
    editTotalAccount:'Edit  TotalAccount',
    addTotalAccount:'New  TotalAccount',
}